(() => {
  const modules = [
    '$sce',
    '$window',
    '$timeout',
    '$rootScope',
    'ModalService',
    'CampaignService',
    'CampaignManagerService',
  ];

  angular
    .module('app.components')
    .directive('tvStatus', [...modules, (
      $sce,
      $window,
      $timeout,
      $rootScope,
      ModalService,
      CampaignService,
      CampaignManagerService,
    ) => ({
        restrict: "E",
        replace: true,
        transclude: true,
        scope: {
          trackpoint: '='
        },
        controller: ['$scope', ($scope) => {
          $scope.active = false;
          $scope.fadeout = false;
          $scope.onMouseOver = () => {
            $scope.active = true;
            $scope.fadeout = false;
          };
          $scope.onMouseLeave = () => {
            $scope.fadeout = true;
            $timeout(() => {
              $scope.active = false;
            }, 500);
          };

          $scope.status = $scope.trackpoint &&
            $scope.trackpoint.properties.featureTV === 'auto' ? 'automatically' : 'manually';

          function onSave() {
            CampaignManagerService.updateCampaign().then(
              // on success
              response => {
                $window.location.reload();
              },
              // on failure
              response => {
                const backupCampaign = {
                  ...CampaignManagerService.getCampaignData()
                };
                CampaignManagerService.setCampaignData(backupCampaign);
                console.error(response.data.error);
              }
            );
          }

          $scope.openTVModal = function () {
            const campaign = {
              ...CampaignManagerService.getCampaignData()
            };

            ModalService
              .showModal({
                templateUrl: '../../assets/js/app/campaign/modals/trackpoint/addressableTV.html',
                controller: 'AddressableTVTrackpointModalController',
                controllerAs: 'tvModal',
                inputs: {
                  campaign: campaign,
                  selectedTrackpoints: [$scope.trackpoint],
                  onSave: onSave
                }
              }).then(function (modal) {
                modal.element.modal();
                modal.close.then(function (result) {});
              });
          };
        }],
        templateUrl: $sce.trustAsResourceUrl('/assets/js/app/components/tvStatus/tvStatus.html')
      })
    ]);
})();
